import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=a3d3cf26&scoped=true"
import script from "./forgot-password.vue?vue&type=script&lang=js"
export * from "./forgot-password.vue?vue&type=script&lang=js"
import style0 from "./forgot-password.vue?vue&type=style&index=0&id=a3d3cf26&prod&scoped=true&lang=css"
import style1 from "./forgot-password.vue?vue&type=style&index=1&id=a3d3cf26&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d3cf26",
  null
  
)

export default component.exports